const DEFAULT_EXCLUDED_PARAMETERS = ['access_token', 'token', 'gem_scr'];

export function removeExcludedParameters(url: string, excludedParameters: string[] = []) {
    const toExcludeParameters = [...DEFAULT_EXCLUDED_PARAMETERS, ...excludedParameters];

    try {
        const parsedUrl = new URL(url);

        toExcludeParameters.forEach((param) => {
            parsedUrl.searchParams.delete(param);
        });

        return parsedUrl.toString();
    } catch {
        return url;
    }
}
